import util from '@/util'
import EventBus from '@/eventBus'

const MESSAGE_TYPES = {
  SLIDE: 'slide',
  WORDCLOUD: 'slideWordCloud',
}

function isUpdateFromDifferentSlide(doc, editor) {
  return doc.data.id != editor.slideActive.id
}

function handleUpdateSlide(doc, editor) {
  if (isUpdateFromDifferentSlide(doc, editor)) {
    return
  }

  const { data } = doc

  const payload = {
    type: doc.type,
    layout: doc.layout,
    multipleChoice: data.multipleChoice,
    limitChoice: data.limitChoice,
    typeChart: data.typeChart || 'barChart',
    hideResult: data.hideResult,
    addCorrectOption: data.addCorrectOption,
    stopSubmission: data.stopSubmission,
    showAllBulletPoints: data.showAllBulletPoints,
    image: data.image,
    imageCaption: data.imageCaption,
    youtubeLink: data.youtubeLink,
    backgroundImage: data.backgroundImage,
    textColour: data.textColour,
    baseColour: data.baseColour,
    visibility: data.visibility,
    showQuestionImage: data.showQuestionImage,
  }

  if (!editor.sharePresentation) {
    payload.showCorrectOption = doc.data.showCorrectOption
  }

  editor.updateSlideActiveAction(payload)
}

async function handleWordcloudUpdate(doc, editor) {
  if (doc.action === 'audience-wordcloud') {
    let index
    const { presentation } = editor.$store.state
    if (doc.data.slideId == editor.slideActive.id) {
      const newSlideOptions = editor.slideActive.SlideOptions.concat(doc.data.options)
      editor.updateSlideActiveAction({
        SlideOptions: newSlideOptions,
      })

      EventBus.$emit('audienceWordCloud')
    } else {
      index = util.getIndexSlide(presentation.slides, doc.data.slideId)
      if (index != -1) {
        presentation.slides[index].SlideOptions = presentation.slides[
          index
        ].SlideOptions.concat(doc.data.options)
      }
    }
  }
}

const SlideWebsocketSubscriber = {
  [MESSAGE_TYPES.SLIDE]: handleUpdateSlide,
  [MESSAGE_TYPES.WORDCLOUD]: handleWordcloudUpdate,
}

export default SlideWebsocketSubscriber
